// extracted by mini-css-extract-plugin
export default {"goToHome":"LoginErrorPage_goToHome__s4NJU"};